module.exports = {
  ACCOUNT_STATUS: {
    LINKED: 'LINKED',
    UNLINKED: 'UNLINKED',
    ARCHIVED: 'ARCHIVED',
    SESSION_EXPIRED: 'SESSION_EXPIRED'
  },
  PAD_STATUS: {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    UNDER_REVIEW: 'UNDER_REVIEW',
    PENDING: 'PENDING'
  },
  FLINKS_RESPONSE_TYPE: {
    KYC_DETAILS: 'KYC',
    ACCOUNT_DETAILS: 'GetAccountsDetail'
  },
  FLINKS_ACCOUNT_TYPE: {
    SAVINGS: 'Savings',
    CHECKING: 'Chequing'
  }
};
